import { useParams } from 'react-router-dom';
import { useConversationStoreShallow } from 'src/store/conversationStore';

import { SkeletonNewReportChatForm } from './ReportConversationForm.skeleton';
import { useReportConversationForm } from './useReportConversationForm';

import {
    ChatFormWrapperActions,
    InnerWrapper,
} from './ReportConversationForm.styled';

export const ReportConversationForm = () => {
    const { caseUuid } = useParams<{ caseUuid: string }>();
    const { groupSlotOptions, loading } = useReportConversationForm(
        caseUuid ?? '',
    );

    const { messages } = useConversationStoreShallow(['messages']);

    return (
        <ChatFormWrapperActions>
            <InnerWrapper>
                {!loading && !!messages.length ? (
                    groupSlotOptions()
                ) : (
                    <SkeletonNewReportChatForm />
                )}
            </InnerWrapper>
        </ChatFormWrapperActions>
    );
};
